import {
  Grid,
  Paper,
  TextField,
  Button,
  Link,
  Alert,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Box,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { Context } from "../Context.js";
import constant from "../Costanti/Constant.js";
import mainLogo from "../img/RatioLogo.svg";
import easyLogo from "../img/EasyGate.svg";
import imageLogoFidalIcona from "../img/logoFidalIcona.jpeg";
import image from "../img/sfondo.jpeg";

const Utenze = { ADMIN: 1, USER: 2, SOCIETA: 3, OPERATORE: 5 };

const Login = () => {
  const { setNome, setToken, setidTipoUtente } = useContext(Context);
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [mode, setMode] = useState("utente");
  const [showPassword, setShowPassword] = useState(false);
  const [msgAlert, setMsgAlert] = useState("");
  const [matches, setMatches] = useState(
    window.matchMedia("(min-width:768px)").matches
  );
  const navigate = useNavigate();

  useEffect(() => {
    window
      .matchMedia("(min-width:768px)")
      .addEventListener("change", (e) => setMatches(e.matches));
  }, []);

  const handleToggleMode = (_, val) => val && setMode(val);
  const handleMouseDownPassword = (e) => e.preventDefault();
  const handleClickShowPassword = () => setShowPassword((s) => !s);

  const goToIscrizione = () => navigate("/iscrizione");
  const goToRecuperaPass = () => navigate("/recuperoPassword");

  const handleLogin = () => {
    fetch(constant.LOGIN, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mail: user,
        password: pass,
        societa: mode === "societa",
      }),
    })
      .then((res) => {
        if (!res.ok) {
          if (res.status === 401)
            throw setMsgAlert("Utente e/o password errati");
          if (res.status === 500) throw setMsgAlert("Uno dei campi è vuoto");
          throw setMsgAlert("Errore");
        }
        return res.json();
      })
      .then((json) => {
        if (json.errore === 0) {
          setNome(json.nome);
          setToken(json.token);
          setidTipoUtente(json.idTipoUtente);
          if (json.idTipoUtente === Utenze.USER) navigate("/abbonamento");
          else if ([Utenze.ADMIN, Utenze.OPERATORE].includes(json.idTipoUtente))
            navigate("/listaAbbonamenti");
          else if (json.idTipoUtente === Utenze.SOCIETA)
            navigate("/abbonamentoSocietaGruppo");
        } else {
          setMsgAlert("Utente e/o password errati");
        }
      });
  };

  const paperStyle = {
    height: "auto",
    width: matches ? "50%" : "80%",
    margin: "1px auto",
  };

  return (
    <div
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper elevation={10} style={paperStyle}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ backgroundColor: "#5E2367", p: 1 }}
            container
            direction="column"
            justifyContent="space-between"
          >
            <img src={easyLogo} width={180} alt="easyLogo" />
            <img src={mainLogo} width={220} alt="logoRatio" />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            container
            direction="column"
            alignItems="center"
            sx={{ p: 4 }}
          >
            <img src={imageLogoFidalIcona} width={150} alt="logoFidal" />
            <h2 className={"loginAccedi"} style={{ marginTop: 16 }}>
              Accedi
            </h2>
            <ToggleButtonGroup
              value={mode}
              exclusive
              onChange={handleToggleMode}
              sx={{ my: 2 }}
            >
              <ToggleButton
                value="utente"
                sx={{
                  "&.Mui-selected": {
                    bgcolor: "primary.main",
                    color: "white",
                    "&:hover": {
                      bgcolor: "primary.dark",
                    },
                  },
                }}
              >
                Utente
              </ToggleButton>
              <ToggleButton
                value="societa"
                sx={{
                  "&.Mui-selected": {
                    bgcolor: "primary.main",
                    color: "white",
                    "&:hover": {
                      bgcolor: "primary.dark",
                    },
                  },
                }}
              >
                Società
              </ToggleButton>
            </ToggleButtonGroup>

            {msgAlert && (
              <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
                {msgAlert}
              </Alert>
            )}

            <TextField
              label="Username"
              fullWidth
              value={user}
              onChange={(e) => setUser(e.target.value)}
              sx={{ mb: 2 }}
            />

            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="pass">Password</InputLabel>
              <OutlinedInput
                id="pass"
                type={showPassword ? "text" : "password"}
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>

            <Link
              onClick={goToRecuperaPass}
              sx={{
                alignSelf: "flex-start",
                mt: 1,
                mb: 3,
                textDecoration: "underline",
                cursor: "pointer",
                color: "#005EA2",
              }}
            >
              Recupera password
            </Link>

            <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
              <Button variant="contained" fullWidth onClick={handleLogin}>
                Accedi
              </Button>
              <Button variant="outlined" fullWidth onClick={goToIscrizione}>
                Registrati
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default Login;
